module.exports = __webpack_public_path__ + "static/media/UneteExtras.45c42233.svg";